import * as actionTypes from '../actions/actionTypes';
import _ from 'lodash'
import { getCookie } from 'src/cookie';
const initialState = {
    materials: null,
    brands: null,
    patterns: null,
    attributes: null,
    colors: null,
    styles: null,
    type_groups: null,
    create_buy_success: false,
    create_item_success: false,
    get_buy_success: null,
    update_item_success: false,
    buy: null,
    item: null,
    update_buy_success: null,
    submit_buy_success: null,
    offer_handled: null,
    QR_url: null,
    deleted_item_id: null

};

const getBrandsSuccess = (state, action) => {
    const newState = {
        ...state,
        brands: [...action.brands],
    }
    return newState
};

const getMaterialsSuccess = (state, action) => {
    const newState = {
        ...state,
        materials: [...action.materials],
    }
    return newState
};
const getPatternsSuccess = (state, action) => {
    const newState = {
        ...state,
        patterns: [...action.patterns],
    }
    return newState
};
const getColorsSuccess = (state, action) => {
    const newState = {
        ...state,
        colors: [...action.colors],
    }
    return newState
};
const getAttributesSuccess = (state, action) => {
    const newState = {
        ...state,
        attributes: [...action.attributes],
    }
    return newState
};
const getStylesSuccess = (state, action) => {
    const newState = {
        ...state,
        styles: [...action.styles],
    }
    return newState
};
const getTypeGroupsSuccess = (state, action) => {
    const newState = {
        ...state,
        type_groups: [...action.typeGroups],
    }
    return newState
};
const getMeasurementsSuccess = (state, action) => {
    const newState = {
        ...state,
        measurements: [...action.measurements],
    }
    return newState
};

const getBuySuccess = (state, action) => {
    const newState = {
        ...state,
        buy: action.buy,
        get_buy_success: action.get_buy_success
    }
    return newState
};
const getBuyStart = (state, action) => {
    const newState = {
        ...state,
        loading: action.loading
    }
    return newState
};
const resetGetBuySuccess = (state, action) => {
    const newState = {
        ...state,
        get_buy_success: action.get_buy_success
    }
    return newState
};
const getItemSuccess = (state, action) => {
    const newState = {
        ...state,
        item: action.item,
    }
    return newState
};

const deleteItemSuccess = (state, action) => {
    let buy = state.buy
    let items = buy.items
    if(getCookie("jwt_token")){
        items = buy.items.filter((item)=>item.id != action.deleted_item_id)
    }
    else{
        items = buy.items.filter((item)=>item.uuid != action.deleted_item_id)
    }
    buy.items = items
    const newState = {
        ...state,
        deleted_item_id: action.deleted_item_id,
        buy: buy,
        loading:action.loading
    }
    return newState
};
const deleteItemStart = (state, action) => {
    const newState = {
        ...state,
        loading: action.loading
    }
    return newState
};
const resetDeletedItemId = (state, action) => {
    const newState = {
        ...state,
        deleted_item_id: null
    }
    return newState
};

const createBuySuccess = (state, action) => {
    const newState = {
        ...state,
        buy: action.buy,
        create_buy_success: action.create_buy_success
    }
    return newState
};
const resetCreateBuySuccess = (state, action) => {
    const newState = {
        ...state,
        create_buy_success: action.create_buy_success
    }
    return newState
};

const createItemSuccess = (state, action) => {
    let newBuy = _.cloneDeep(state.buy)
    newBuy.items.push(action.item)
    const newState = {
        ...state,
        buy: newBuy,
        create_item_success: action.create_item_success
    }
    return newState
};
const resetCreateItemSuccess = (state, action) => {
    const newState = {
        ...state,
        create_item_success: action.create_item_success,
    }
    return newState
};
const updateBuySuccess = (state, action) => {
    const newState = {
        ...state,
        buy: action.buy,
        loading: action.loading,
        update_buy_success: action.update_buy_success,
    }
    return newState
};
const updateBuyStart = (state, action) => {
    const newState = {
        ...state,
        loading: action.loading,
    }
    return newState
};
const resetUpdateBuySuccess = (state, action) => {
    const newState = {
        ...state,
        update_buy_success: action.update_buy_success
    }
    return newState
};
const updateItemSuccess = (state, action) => {
    let updatedBuy = { ...state.buy }
    for (let i = 0; i < updatedBuy.items.length; i++) {
        if (updatedBuy.items[i].id == action.item.id) {
            updatedBuy.items[i] = action.item
            break;
        }
    }
    const newState = {
        ...state,
        item: action.item,
        buy: updatedBuy,
        error: action.error,
        update_item_success: action.update_item_success,
        loading: action.loading
    }
    return newState
};
const resetUpdateItemSuccess = (state, action) => {
    const newState = {
        ...state,
        update_item_success: action.update_item_success,
    }
    return newState
};
const updateItemStart = (state, action) => {
    const newState = {
        ...state,
        loading: action.loading,
    }
    return newState
};

const submitBuySuccess = (state, action) => {
    const newState = {
        ...state,
        submit_buy_success: action.submit_buy_success,
        buy: action.buy,
        error: action.error,
        loading: action.loading
    }
    return newState
};
const submitBuyStart = (state, action) => {
    const newState = {
        ...state,
        loading: action.loading
    }
    return newState
};
const resetSubmitBuySuccess = (state, action) => {
    const newState = {
        ...state,
        submit_buy_success: action.submit_buy_success,
    }
    return newState
};


const getQRCodeSuccess = (state, action) => {
    const newState = {
        ...state,
        loading: action.loading,
        QR_url: action.QR_url
    }
    return newState
};
const getQRCodeStart = (state, action) => {
    const newState = {
        ...state,
        loading: action.loading,
    }
    return newState
};

const handleOfferSuccess = (state, action) => {
    const newState = {
        ...state,
        offer_handled: action.offerHandled,
        buy: action.buy
    }
    return newState
};
const handleOfferStart = (state, action) => {
    const newState = {
        ...state,
        loading: action.loading,
    }
    return newState
};

const getCustomerSuccess = (state, action) => {
    if (action.customer.last_open_buy_id)
        return state
    else {
        const newState = {
            ...state,
            buy: null
        }
        return newState
    }
};


const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_BRANDS_SUCCESS: return getBrandsSuccess(state, action);
        case actionTypes.GET_MEASUREMENTS_SUCCESS: return getMeasurementsSuccess(state, action);
        case actionTypes.GET_BUY_SUCCESS: return getBuySuccess(state, action);
        case actionTypes.GET_BUY_START: return getBuyStart(state, action);
        case actionTypes.RESET_GET_BUY_SUCCESS: return resetGetBuySuccess(state, action);
        case actionTypes.DELETE_ITEM_SUCCESS: return deleteItemSuccess( state, action );
        case actionTypes.DELETE_ITEM_START: return deleteItemStart( state, action );
        case actionTypes.RESET_DELETED_ITEM_ID: return resetDeletedItemId( state, action );
        case actionTypes.CREATE_BUY_SUCCESS: return createBuySuccess(state, action);
        case actionTypes.RESET_CREATE_BUY_SUCCESS: return resetCreateBuySuccess(state, action);
        case actionTypes.GET_MATERIALS_SUCCESS: return getMaterialsSuccess(state, action);
        case actionTypes.GET_PATTERNS_SUCCESS: return getPatternsSuccess(state, action);
        case actionTypes.GET_COLORS_SUCCESS: return getColorsSuccess(state, action);
        case actionTypes.GET_ATTRIBUTES_SUCCESS: return getAttributesSuccess(state, action);
        case actionTypes.GET_STYLES_SUCCESS: return getStylesSuccess(state, action);
        case actionTypes.GET_TYPE_GROUPS_SUCCESS: return getTypeGroupsSuccess(state, action);
        case actionTypes.UPDATE_ITEM_SUCCESS: return updateItemSuccess(state, action);
        case actionTypes.UPDATE_ITEM_START: return updateItemStart(state, action);
        case actionTypes.RESET_UPDATE_ITEM_SUCCESS: return resetUpdateItemSuccess(state, action);
        case actionTypes.GET_ITEM_SUCCESS: return getItemSuccess(state, action);
        case actionTypes.CREATE_ITEM_SUCCESS: return createItemSuccess(state, action);
        case actionTypes.RESET_CREATE_ITEM_SUCCESS: return resetCreateItemSuccess(state, action);
        case actionTypes.UPDATE_BUY_SUCCESS: return updateBuySuccess(state, action);
        case actionTypes.RESET_UPDATE_BUY_SUCCESS: return resetUpdateBuySuccess(state, action);
        case actionTypes.UPDATE_BUY_START: return updateBuyStart(state, action);
        case actionTypes.SUBMIT_BUY_SUCCESS: return submitBuySuccess(state, action);
        case actionTypes.SUBMIT_BUY_START: return submitBuyStart(state, action);
        case actionTypes.RESET_SUBMIT_BUY_SUCCESS: return resetSubmitBuySuccess(state, action);
        case actionTypes.GET_QR_CODE_SUCCESS: return getQRCodeSuccess(state, action);
        case actionTypes.GET_QR_CODE_START: return getQRCodeStart(state, action);
        case actionTypes.HANDLE_OFFER_SUCCESS: return handleOfferSuccess(state, action);
        case actionTypes.HANDLE_OFFER_START: return handleOfferStart(state, action);
        case actionTypes.GET_CUSTOMER_SUCCESS: return getCustomerSuccess(state, action);

        default: return state;
    }
};

export default reducer;